import { CaretUp, CaretDown } from "@phosphor-icons/react";

/** Phase 259 — Shared sortable column header for all list-page tables.
 * Click to toggle sort key + direction; shows Caret indicator on the active
 * column. Use as a `<th>` inside a `<thead>` row.
 *
 * Usage:
 *   const [sortKey, setSortKey] = useState("name");
 *   const [sortDir, setSortDir] = useState("asc");
 *   const toggle = (k) => { sortKey === k ? setSortDir(d => d === "asc" ? "desc" : "asc")
 *                                          : (setSortKey(k), setSortDir("asc")); };
 *   <SortHeader label="Name" k="name" sortKey={sortKey} sortDir={sortDir} onToggle={toggle} />
 */
export default function SortHeader({
  label, k, sortKey, sortDir, onToggle, className = "", align = "left", testidPrefix = "sort",
}) {
  const active = sortKey === k;
  const alignCls = align === "right" ? "justify-end text-right" : "text-left";
  return (
    <th
      onClick={() => onToggle(k)}
      className={`px-4 py-2.5 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground cursor-pointer select-none hover:text-foreground transition-colors group ${className}`}
      data-testid={`${testidPrefix}-${k}`}
    >
      <span className={`flex items-center gap-1 ${alignCls}`}>
        {label}
        {active ? (
          sortDir === "asc"
            ? <CaretUp size={10} weight="bold" className="text-primary" />
            : <CaretDown size={10} weight="bold" className="text-primary" />
        ) : (
          <CaretDown size={10} className="opacity-0 group-hover:opacity-40 transition-opacity" />
        )}
      </span>
    </th>
  );
}
